export const excludeHealthProbesTelemetryProcessor = envelope => {
  const data = envelope.data;
  if (data.baseType === 'RequestData' && data.baseData?.name.startsWith('GET /health/')) {
    return false;
  }
  if (data.baseType === 'RemoteDependencyData' && data.baseData?.properties?.url?.startsWith('/health/')) {
    return false;
  }
  return true;
};
//# sourceMappingURL=excludeHealthProbesTelemetryProcessor.js.map